import { Component, ElementRef, Injector, ViewChild } from '@angular/core';
import {
    filter,
    map,
    pluck,
    shareReplay,
    startWith,
    switchMap,
    takeUntil
} from 'rxjs/operators';
import {
    ActivatedRoute,
    NavigationEnd,
    Router,
    RouterLink,
    RouterOutlet
} from '@angular/router';
import { PrivateAssetQuery } from '../../../../pages/authenticated/private-asset/state/private-asset.query';
import {
    ActionEvent,
    ModalActionService
} from '../../../../features/modal/services/modal-action.service';
import { combineLatest, Observable, ReplaySubject, Subject } from 'rxjs';
import { InstrumentsQuery } from '../../../state/instruments/instruments.query';
import { SbModalHeaderComponent } from '../sb-modal-header/sb-modal-header.component';
import { SbModalBodyComponent } from '../sb-modal-body/sb-modal-body.component';
import { CommonModule } from '@angular/common';
import { SbModalComponent } from '../../sb-modal/sb-modal.component';
import { SbPillsComponent } from '../../sb-pills/sb-pills.component';
import { SbModalFooterComponent } from '../sb-modal-footer/sb-modal-footer.component';
import { SbPendingButtonIndicatorComponent } from '../../sb-pending-button-indicator/sb-pending-button-indicator.component';
import { StrictTitleCasePipe } from '../../../pipes/strict-title-case.pipe';
import { SbCompanyLogoComponent } from '../../sb-company-logo/sb-company-logo.component';
import { PrivateAssetService } from 'src/app/pages/authenticated/private-asset/state/private-asset.service';
import { TransactionsService } from 'src/app/features/transactions/state/transactions.service';

/** @deprecated - This component should not be used */
// Although it is being used and that's why we are doing development on it still..
@Component({
    templateUrl: './sb-view-instrument.component.html',
    styles: [],
    providers: [ModalActionService],
    imports: [
        CommonModule,
        SbModalHeaderComponent,
        SbModalBodyComponent,
        SbModalComponent,
        SbPillsComponent,
        RouterOutlet,
        SbModalFooterComponent,
        SbPendingButtonIndicatorComponent,
        StrictTitleCasePipe,
        SbCompanyLogoComponent,
        RouterLink
    ],
    standalone: true
})
export class SbViewInstrumentComponent {
    @ViewChild('modalBody') modalBody: ElementRef;
    @ViewChild('canvas') canvas: ElementRef<HTMLCanvasElement>;

    routes = this.route?.routeConfig?.children?.map((route) => ({
        path: `./${route.path}`,
        label: route.data.title
    }));

    unsubscribe$ = new Subject();

    constructor(
        private injector: Injector,
        private privateAssetQuery: PrivateAssetQuery,
        private instrumentsQuery: InstrumentsQuery,
        private route: ActivatedRoute,
        private router: Router,
        public modalActionService: ModalActionService,
        private privateAssetService: PrivateAssetService,
        private transactionsService: TransactionsService
    ) {
        // We need to get the id from route params
        let id;
        if (this.route.snapshot.params.id) {
            id = this.route.snapshot.params.id;
        } else if (this.route.snapshot.params.companyInstrumentId) {
            id = this.route.snapshot.params.companyInstrumentId;
        }

        // Construction of this component requires transaction data for the
        // instrument and the instrument as underlying instrument.
        this.transactionsService
            .getTransactionsForInstrumentId(id as number)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe();

        this.transactionsService
            .getTransactionsForUnderlyingInstrumentId(id as number)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe();
    }

    ngOnDestroy() {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    data$ = this.router.events.pipe(
        filter((event) => event instanceof NavigationEnd),
        map((_) => this.route.snapshot.firstChild.data),
        startWith(this.route.snapshot.firstChild.data)
    );

    actions$: Observable<Array<any>> = this.data$.pipe(
        pluck('actions'),
        map((actions) =>
            actions.map((action) => ({ ...action, state$: new ReplaySubject(1) }))
        ),
        shareReplay(1)
    );

    /*asset$ = this.route.params.pipe(
        pluck('id'),
        switchMap((id) => this.privateAssetQuery.selectEntity(id))
    );*/

    instrument$ = this.route.params.pipe(
        pluck('id'),
        switchMap((id) => this.instrumentsQuery.selectEntity(id))
    );

    callAction(action: ActionEvent, $event) {
        this.modalActionService.callAction(action.id, $event, action.state$);
    }

    isLoading$ = this.actions$.pipe(
        switchMap((actions) =>
            combineLatest([
                ...actions.reduce(
                    (acc, value) => [...acc, value.state$.pipe(startWith(null))],
                    []
                )
            ])
        ),
        map((res) => !!res.find((state) => state === 'loading')),
        shareReplay(1)
    );

    id$: Observable<number> = this.route.params.pipe(pluck('id'), shareReplay(1));

    activeImage$: Observable<string> = this.id$.pipe(
        switchMap((id) => this.privateAssetService.readImage(id)), //try 34 PA
        shareReplay(1)
    );
}
